<footer class="mt-footer">
  <div class="container">
    <div class="row footer-content">
      <div class="col-12 col-lg-5 footer-brand">
        <a routerLink="/" class="footer-logo-link" aria-label="MemberTrace home">
          <img src="/img/MT-Logo-White.webp" alt="MemberTrace Logo" class="footer-logo" />
        </a>
        <p class="footer-description">
          MemberTrace helps teams manage members, events, dues, reporting, and growth in one place.
        </p>
      </div>

      <div class="col-6 col-md-4 col-lg-3 footer-links">
        <h3 class="footer-heading">Explore</h3>
        <ul>
          <li><a routerLink="/for-operators">For operators</a></li>
          <li><a routerLink="/communities">Communities</a></li>
          <li><a routerLink="/start-a-community">Start a Community</a></li>
          <li><a routerLink="/pricing">Pricing</a></li>
          <li><a routerLink="/mobile">Mobile app</a></li>
          <li><a routerLink="/resources">Resources</a></li>
          <li><a routerLink="/contact">Contact</a></li>
        </ul>
      </div>

      <div class="col-6 col-md-4 col-lg-3 footer-links">
        <h3 class="footer-heading">Access</h3>
        <ul>
          <li><a routerLink="/contact" [queryParams]="{ inquiryType: 'demo' }" (click)="onDemoCta()">Book a demo</a></li>
          <li><a routerLink="/login">Login</a></li>
          <li><a routerLink="/security">Security</a></li>
          <li><a routerLink="/privacy">Privacy</a></li>
          <li><a routerLink="/terms">Terms</a></li>
          <li><a routerLink="/data-deletion">Data deletion</a></li>
        </ul>
      </div>
    </div>

    <div class="footer-divider"></div>

    <div class="row footer-bottom">
      <div class="col-12 col-md-6 copyright">
        <p>&copy; {{ currentYear }} MemberTrace. All rights reserved.</p>
      </div>
      <div class="col-12 col-md-6 footer-bottom-note">
        <p>Built for professional communities.</p>
      </div>
    </div>
  </div>
</footer>
